import { render } from "./LoaderComponent.vue?vue&type=template&id=7f122a72&scoped=true"
import script from "./LoaderComponent.vue?vue&type=script&lang=js"
export * from "./LoaderComponent.vue?vue&type=script&lang=js"

import "./LoaderComponent.vue?vue&type=style&index=0&id=7f122a72&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f122a72"]])

export default __exports__